import { Card, Container, Stack } from "@bookingcom/bui-react";
import { StaticContent } from "../components/StaticContent";
import contentForAirline from "../content/HowToGuideForAirline.md?raw";
import contentForEtg from "../content/HowToGuideForEtg.md?raw";
import { useAuth } from "../hooks/useAuth";

export const HowToGuideComponent = () => {
  const { isAirlineUser } = useAuth();

  return (
    <Stack mixin={{ minHeight: "100vh", paddingBlockStart: 8, paddingBlockEnd: 16 }}>
      <Container>
        <Card mixin={{ padding: 6 }}>
          <StaticContent content={isAirlineUser ? contentForAirline : contentForEtg} />
        </Card>
      </Container>
    </Stack>
  );
};
